import {Pipe, PipeTransform} from '@angular/core';
import {SelectPrestationTypeOption} from "@shared/module/forms/component";
import {SelectPrestationTypeOptionGroupDto} from "@prestationType/model";

@Pipe({
  name: 'groupSelectPrestationType'
})
export class GroupSelectPrestationTypePipe implements PipeTransform {
  transform(value: SelectPrestationTypeOption[]): SelectPrestationTypeOptionGroupDto[] {
    const list: SelectPrestationTypeOptionGroupDto[] = [];
    for (let prestation of value) {
      let groupExists = list.some(x => x.groupId == prestation.value.prestationGroup?.prestation_group_id);
      if (groupExists) {
        list.filter(x => x.groupId == prestation.value.prestationGroup?.prestation_group_id)[0].prestations.push(prestation);
      } else if(!prestation.value.prestationGroup?.prestation_group_id) {
        list.push({
          name: "N/A",
          description: "N/A",
          groupId: undefined,
          prestations: [prestation]
        });
      } else {
        list.push({
          name: prestation.value.prestationGroup.name,
          description: prestation.value.prestationGroup.description,
          groupId: prestation.value.prestationGroup.prestation_group_id,
          prestations: [prestation]
        });
      }
    }

    return list;
  }
}
